/**
 * plch-tabs.js — Navigation SPA-like entre collections
 *
 * Intercepte les clics sur les tabs, fetch la nouvelle page,
 * swap le #collection-content avec transition, pushState.
 * Le contexte hub (animaux / geant / bebe) vient de l'URL (?ctx=)
 * ou du rendu serveur (data-nav-ctx) — jamais conservé à tort entre pages.
 * Fallback sans JS : liens <a> classiques.
 */

(function () {
  'use strict';

  const CONTENT_ID = 'collection-content';
  const FAQ_ID = 'plch-faq-collection';
  const BLOC_ID = 'plch-bloc-collection';
  const TITLE_ID = 'plch-collection-title';
  const DESC_ID = 'plch-collection-description';
  const BREADCRUMB_ID = 'plch-breadcrumb';
  const ACTIVE_CLASS = 'plch-tabs__item--active';
  const LOADING_CLASS = 'plch-loading';

  const NAV_ARIA = {
    animaux: 'Collections animaux',
    geant: 'Collections peluches géantes',
    bebe: 'Collections peluches bébé et doudous'
  };

  const nav = document.querySelector('.plch-tabs');
  if (!nav) return;

  function closestFromEvent(e, selector) {
    var el = e.target;
    if (!el || el.nodeType !== 1) {
      el = el && el.parentElement ? el.parentElement : null;
    }
    if (!el || typeof el.closest !== 'function') return null;
    return el.closest(selector);
  }

  function getUrlContext(url) {
    try {
      var parsed = url ? new URL(url, window.location.origin) : new URL(window.location.href);
      var ctx = parsed.searchParams.get('ctx');
      if (ctx === 'bebe' || ctx === 'geant') return ctx;
    } catch (err) {
      /* noop */
    }
    return 'animaux';
  }

  function getNavContext() {
    return nav.getAttribute('data-nav-ctx') || 'animaux';
  }

  /** Contexte cible : ?ctx= explicite, sinon rendu serveur de la page destination. */
  function resolveNavContext(url, serverCtx) {
    var urlCtx = getUrlContext(url);
    if (urlCtx !== 'animaux') return urlCtx;
    if (serverCtx === 'geant' || serverCtx === 'bebe' || serverCtx === 'animaux') {
      return serverCtx;
    }
    return 'animaux';
  }

  function getTrack(ctx) {
    var trackCtx = ctx || getNavContext();
    return nav.querySelector('.plch-tabs__track[data-hub-track="' + trackCtx + '"]');
  }

  function setContextVisibility(el, isActive) {
    el.hidden = !isActive;
    el.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  }

  function switchNavContext(ctx) {
    if (ctx !== 'animaux' && ctx !== 'geant' && ctx !== 'bebe') {
      ctx = 'animaux';
    }

    nav.setAttribute('data-nav-ctx', ctx);
    nav.setAttribute('aria-label', NAV_ARIA[ctx] || NAV_ARIA.animaux);

    nav.querySelectorAll('[data-hub-track]').forEach(function (track) {
      setContextVisibility(track, track.getAttribute('data-hub-track') === ctx);
    });

    document.querySelectorAll('[data-nav-ctx-panel]').forEach(function (panel) {
      setContextVisibility(panel, panel.getAttribute('data-nav-ctx-panel') === ctx);
    });

    bindTrackScroll();
    updateFades();
  }

  function normalizeUrl(value) {
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      return parsed.pathname + parsed.search;
    } catch (e) {
      return '';
    }
  }

  function urlsMatch(a, b) {
    return normalizeUrl(a) === normalizeUrl(b);
  }

  function isSamePageNav(href) {
    return urlsMatch(href, window.location.href);
  }

  function getLinkHref(link) {
    return link.getAttribute('href') || link.href || '';
  }

  function updateFades() {
    var track = getTrack();
    if (!track) return;

    const fadeEnd = nav.querySelector('.plch-tabs__fade--end');
    const fadeStart = nav.querySelector('.plch-tabs__fade--start');
    const scrollLeft = track.scrollLeft;
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (fadeEnd) {
      fadeEnd.style.opacity = maxScroll > 2 && scrollLeft < maxScroll - 2 ? '1' : '0';
    }
    if (fadeStart) {
      fadeStart.style.opacity = scrollLeft > 2 ? '1' : '0';
    }
  }

  function bindTrackScroll() {
    nav.querySelectorAll('.plch-tabs__track').forEach(function (track) {
      if (!track.dataset.plchFadeBound) {
        track.dataset.plchFadeBound = 'true';
        track.addEventListener('scroll', updateFades, { passive: true });
      }
    });
  }

  bindTrackScroll();
  window.addEventListener('resize', updateFades, { passive: true });
  updateFades();

  function scrollActiveTabIntoView() {
    var track = getTrack();
    const activeTab = track ? track.querySelector('.' + ACTIVE_CLASS) : null;
    if (activeTab && track) {
      activeTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function setActiveTab(url) {
    var targetUrl = normalizeUrl(url);
    var ctx = getNavContext();
    var track = getTrack(ctx);
    if (!track) return;

    const tabs = track.querySelectorAll('.plch-tabs__item');
    var matched = false;

    tabs.forEach(function (tab) {
      const href = tab.getAttribute('href');
      var tabUrl = normalizeUrl(href);
      if (tabUrl && tabUrl === targetUrl) {
        tab.classList.add(ACTIVE_CLASS);
        tab.setAttribute('aria-current', 'page');
        matched = true;
      } else {
        tab.classList.remove(ACTIVE_CLASS);
        tab.removeAttribute('aria-current');
      }
    });

    if (!matched) {
      syncActiveTabFromSidebar();
    } else {
      requestAnimationFrame(scrollActiveTabIntoView);
    }
  }

  /** Sous-collection : active l'onglet parent lu depuis la sidebar (ex. doudou-tortue → peluche-tortue). */
  function syncActiveTabFromSidebar() {
    var panel = document.querySelector('[data-nav-ctx-panel]:not([hidden])');
    if (!panel) return;

    var currentLink = panel.querySelector('.plch-sub-collections__link--current');
    if (!currentLink) return;

    var listLinks = panel.querySelectorAll('.plch-sub-collections__link');
    if (listLinks.length < 2) return;

    var parentLink = listLinks[0];
    if (currentLink === parentLink) return;

    var parentUrl = normalizeUrl(getLinkHref(parentLink));
    var track = getTrack();
    if (!track || !parentUrl) return;

    track.querySelectorAll('.plch-tabs__item').forEach(function (tab) {
      var tabUrl = normalizeUrl(tab.getAttribute('href'));
      if (tabUrl && tabUrl === parentUrl) {
        tab.classList.add(ACTIVE_CLASS);
        tab.setAttribute('aria-current', 'page');
      } else {
        tab.classList.remove(ACTIVE_CLASS);
        tab.removeAttribute('aria-current');
      }
    });

    requestAnimationFrame(scrollActiveTabIntoView);
  }

  requestAnimationFrame(function () {
    setActiveTab(window.location.href);
  });

  let isNavigating = false;
  var pageCache = new Map();
  var inflightFetches = new Map();
  var MAX_CACHE_SIZE = 8;

  function swapTabsNav(doc) {
    var newNav = doc.querySelector('.plch-tabs');
    if (!newNav || !nav) return;

    var newTracks = newNav.querySelectorAll('[data-hub-track]');

    if (newTracks.length > 0) {
      newTracks.forEach(function (newTrack) {
        var hub = newTrack.getAttribute('data-hub-track');
        var curTrack = nav.querySelector('[data-hub-track="' + hub + '"]');
        if (curTrack) {
          curTrack.innerHTML = newTrack.innerHTML;
        }
      });
      nav.setAttribute('data-nav-ctx', newNav.getAttribute('data-nav-ctx') || 'animaux');
      return;
    }

    nav.innerHTML = newNav.innerHTML;
    bindTrackScroll();
  }

  function swapSidebarPanels(doc) {
    var newPanelsRoot = doc.getElementById('plch-sub-collections-panels');
    var curPanelsRoot = document.getElementById('plch-sub-collections-panels');

    if (newPanelsRoot && curPanelsRoot) {
      curPanelsRoot.innerHTML = newPanelsRoot.innerHTML;
    }
  }

  /**
   * Récupère le HTML d'une page et le met en cache sous forme de chaîne.
   * On ne stocke pas de Document parsé : 8 DOM détachés de page collection
   * (header + footer + 24 cartes) pèsent des dizaines de Mo sur mobile.
   * Le prefetch se contente de cette chaîne, le parsing n'a lieu qu'à la navigation.
   */
  function fetchPage(url) {
    var cacheKey = normalizeUrl(url);
    var cachedHtml = pageCache.get(cacheKey);
    if (cachedHtml) {
      return Promise.resolve(cachedHtml);
    }

    if (inflightFetches.has(cacheKey)) {
      return inflightFetches.get(cacheKey);
    }

    var promise = fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        inflightFetches.delete(cacheKey);
        if (!response.ok) return null;
        return response.text();
      })
      .then(function (html) {
        if (!html) return null;
        if (pageCache.size >= MAX_CACHE_SIZE) {
          var firstKey = pageCache.keys().next().value;
          if (firstKey) pageCache.delete(firstKey);
        }
        pageCache.set(cacheKey, html);
        return html;
      })
      .catch(function () {
        inflightFetches.delete(cacheKey);
        return null;
      });

    inflightFetches.set(cacheKey, promise);
    return promise;
  }

  function fetchAndParse(url) {
    return fetchPage(url).then(function (html) {
      if (!html) return null;
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  /**
   * Remplace un conteneur persistant (bloc SEO secondaire, FAQ) par son équivalent
   * de la page destination. Le report de `hidden` et des classes est indispensable :
   * sans lui, le contenu de la collection précédente reste affiché sur la suivante.
   * @returns {Element|null} le conteneur mis à jour, ou null s'il n'existe pas ici
   */
  function swapPersistentBlock(doc, id) {
    var current = document.getElementById(id);
    var next = doc.getElementById(id);
    if (!current || !next) return null;

    current.innerHTML = next.innerHTML;
    current.className = next.className;
    if (next.hasAttribute('hidden')) {
      current.setAttribute('hidden', '');
    } else {
      current.removeAttribute('hidden');
    }
    return current;
  }

  async function navigateTo(url, pushToHistory) {
    if (isNavigating) return;
    isNavigating = true;

    try {
      if (typeof pushToHistory === 'undefined') pushToHistory = true;

      var contentEl = document.getElementById(CONTENT_ID);
      var contentSectionEl = contentEl ? contentEl.closest('.shopify-section') : null;
      if (!contentEl) {
        window.location.href = url;
        return;
      }

      var titleEl = document.getElementById(TITLE_ID);
      var descEl = document.getElementById(DESC_ID);

      contentEl.classList.add(LOADING_CLASS);

      var doc = await fetchAndParse(url);

      if (!doc) {
        window.location.href = url;
        return;
      }

      var newContent = doc.getElementById(CONTENT_ID);
      var swappedFullSection = false;

      if (!newContent) {
        window.location.href = url;
        return;
      }

      if (contentSectionEl && contentSectionEl.id) {
        var newContentSectionEl = doc.getElementById(contentSectionEl.id);
        if (newContentSectionEl) {
          contentSectionEl.innerHTML = newContentSectionEl.innerHTML;
          swappedFullSection = true;
          contentEl = document.getElementById(CONTENT_ID);
          contentSectionEl = contentEl ? contentEl.closest('.shopify-section') : contentSectionEl;
        }
      }

      if (!swappedFullSection) {
        contentEl.innerHTML = newContent.innerHTML;
      }

      swapTabsNav(doc);
      swapSidebarPanels(doc);

      var faqEl = swapPersistentBlock(doc, FAQ_ID);
      if (faqEl) reinitializeScripts(faqEl);

      swapPersistentBlock(doc, BLOC_ID);

      var newTitle = doc.getElementById(TITLE_ID);
      var newDesc = doc.getElementById(DESC_ID);
      var newBreadcrumb = doc.getElementById(BREADCRUMB_ID);
      var breadcrumbEl = document.getElementById(BREADCRUMB_ID);

      if (titleEl && newTitle) titleEl.innerHTML = newTitle.innerHTML;
      if (descEl && newDesc) {
        descEl.innerHTML = newDesc.innerHTML;
        descEl.hidden = newDesc.hidden;
      }
      if (breadcrumbEl && newBreadcrumb) breadcrumbEl.innerHTML = newBreadcrumb.innerHTML;

      var newPageTitle = doc.querySelector('title');
      if (newPageTitle) document.title = newPageTitle.textContent;

      var historyUrl = normalizeUrl(url);
      if (pushToHistory) {
        history.pushState({ plchTabs: true, url: historyUrl }, '', historyUrl);
      }

      var newNav = doc.querySelector('.plch-tabs');
      var serverCtx = newNav ? newNav.getAttribute('data-nav-ctx') : 'animaux';
      switchNavContext(resolveNavContext(url, serverCtx));
      setActiveTab(url);

      if (contentEl) {
        contentEl.classList.remove(LOADING_CLASS);
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (swappedFullSection && contentSectionEl) {
        reinitializeScripts(contentSectionEl);
      } else if (contentEl) {
        reinitializeScripts(contentEl);
      }
    } catch (e) {
      window.location.href = url;
    } finally {
      isNavigating = false;
    }
  }

  function reinitializeScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      // Les JSON-LD ne s'exécutent jamais : innerHTML les a déjà posés dans le DOM,
      // les recréer ne fait que du travail inutile à chaque navigation.
      if (oldScript.type === 'application/ld+json') return;

      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });

    var resultsList = container.querySelector('results-list');
    if (resultsList && typeof resultsList.connectedCallback === 'function') {
      resultsList.connectedCallback();
    }
  }

  function handleNavClick(e, link) {
    var href = getLinkHref(link);
    if (!href || href === '#' || isSamePageNav(href)) return;

    if (!link.origin || link.origin === window.location.origin) {
      e.preventDefault();
      navigateTo(href);
    }
  }

  nav.addEventListener('click', function (e) {
    var link = closestFromEvent(e, '.plch-tabs__item');
    if (!link) return;
    handleNavClick(e, link);
  });

  document.addEventListener('click', function (e) {
    var link = closestFromEvent(e, '.plch-sub-collections__link');
    if (!link) return;
    handleNavClick(e, link);
  });

  var hoverTimer = null;

  nav.addEventListener('mouseover', function (e) {
    var link = closestFromEvent(e, '.plch-tabs__item');
    if (!link) return;

    var href = getLinkHref(link);
    if (!href || href === '#' || isSamePageNav(href)) return;
    var cacheKey = normalizeUrl(href);
    if (pageCache.has(cacheKey) || inflightFetches.has(cacheKey)) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      fetchPage(href);
    }, 80);
  });

  nav.addEventListener('mouseout', function (e) {
    if (closestFromEvent(e, '.plch-tabs__item')) {
      clearTimeout(hoverTimer);
    }
  });

  nav.addEventListener('touchstart', function (e) {
    var link = closestFromEvent(e, '.plch-tabs__item');
    if (!link) return;

    var href = getLinkHref(link);
    if (!href || href === '#' || isSamePageNav(href)) return;

    fetchPage(href);
  }, { passive: true });

  var sidebarHoverTimer = null;

  function prefetchSidebarLink(link) {
    if (!link || link.origin !== window.location.origin) return;
    var href = getLinkHref(link);
    if (!href || isSamePageNav(href)) return;
    var cacheKey = normalizeUrl(href);
    if (pageCache.has(cacheKey) || inflightFetches.has(cacheKey)) return;
    fetchPage(href);
  }

  document.addEventListener('mouseover', function (e) {
    var link = closestFromEvent(e, '.plch-sub-collections__link');
    if (!link) return;

    clearTimeout(sidebarHoverTimer);
    sidebarHoverTimer = setTimeout(function () {
      prefetchSidebarLink(link);
    }, 80);
  });

  document.addEventListener('mouseout', function (e) {
    if (closestFromEvent(e, '.plch-sub-collections__link')) {
      clearTimeout(sidebarHoverTimer);
    }
  });

  document.addEventListener('touchstart', function (e) {
    var link = closestFromEvent(e, '.plch-sub-collections__link');
    if (link) prefetchSidebarLink(link);
  }, { passive: true });

  window.addEventListener('popstate', function (e) {
    var url = (e.state && e.state.url) ? e.state.url : window.location.href;
    navigateTo(url, false);
  });

  history.replaceState(
    { plchTabs: true, url: normalizeUrl(window.location.href) },
    '',
    window.location.href
  );
})();
